export default "__VITE_ASSET__fe500efa__"